let previousWidth = window.innerWidth;
let isInitialized = false;

function initToggle(forceInit = false) {
    const footerColumns = document.querySelectorAll('.footer-column');
    const toggleHeaders = document.querySelectorAll('.list-toggle-header');
    const currentWidth = window.innerWidth;
    const breakpoint = 1200;

    // Check if we crossed the breakpoint or if this is the first init
    const wasMobile = previousWidth <= breakpoint;
    const isMobile = currentWidth <= breakpoint;
    const crossedBreakpoint = wasMobile !== isMobile;

    // Only re-initialize if we crossed the breakpoint or this is the first init
    if (!forceInit && isInitialized && !crossedBreakpoint) {
        previousWidth = currentWidth;
        return;
    }

    previousWidth = currentWidth;
    isInitialized = true;

    if (isMobile) {
        footerColumns.forEach(function (column) {
            const contentBox = column.querySelector('.content-box');
            if (contentBox) {
                // Only reset if crossing from desktop to mobile
                if (crossedBreakpoint || forceInit) {
                    contentBox.style.maxHeight = '0';
                }
                contentBox.style.overflow = 'hidden';
            }
        });

        toggleHeaders.forEach(function (header) {
            header.removeEventListener('click', toggleFooter);
            header.addEventListener('click', toggleFooter);
        });
    } else {
        footerColumns.forEach(function (column) {
            const contentBox = column.querySelector('.content-box');
            if (contentBox) {
                contentBox.style.maxHeight = 'none';
            }
            column.classList.remove('acc_active');
        });

        toggleHeaders.forEach(function (header) {
            header.removeEventListener('click', toggleFooter);
        });
    }
}

function toggleFooter(event) {
    const currentColumn = event.target.closest('.footer-column');
    const currentList = currentColumn.querySelector('.content-box');
    const allColumns = document.querySelectorAll('.footer-column');

    allColumns.forEach(function (column) {
        if (column !== currentColumn) {
            column.classList.remove('acc_active');
            const contentBox = column.querySelector('.content-box');
            if (contentBox) {
                contentBox.style.maxHeight = '0';
            }
        }
    });

    if (currentColumn.classList.contains('acc_active')) {
        currentColumn.classList.remove('acc_active');
        currentList.style.maxHeight = '0';
    } else {
        currentColumn.classList.add('acc_active');
        currentList.style.maxHeight = currentList.scrollHeight + 'px';
    }
}

initToggle(true);
window.addEventListener('resize', function() {
    initToggle(false);
});
 